export default __webpack_public_path__ + "static/media/Roles&Rights.a6a459e2.svg";